module.exports = require("./fr-MR.d.ts");